"use client";

import useCaptureGraphQLError from "./useCaptureGraphQLError";
import useMutationOnError from "./useMutationOnError";
import useMutationOnSuccess from "./useMutationOnSuccess";

export {
	useCaptureGraphQLError,
	useMutationOnError as useLazyQueryOnError,
	useMutationOnSuccess as useLazyQueryOnSuccess,
	useMutationOnError,
	useMutationOnSuccess,
};
